export default __webpack_public_path__ + "static/media/graphic-06.89a025bb.png";